import { createSelector } from '@reduxjs/toolkit';
import { matchPath } from 'react-router-dom-v5-compat';

import { config } from '@/config/config';
import { selectRouting } from '@/services/selectors';

export const selectActiveVaultId = createSelector(
    selectRouting,
    ({ location }) => matchPath(config.routes.vault, location?.pathname ?? '')?.params.vaultId ?? null,
);
